<template>
    <div class="c-app">
        <Sidebar :is-authenticated="false"/>
        <CWrapper>
            <Header :is-authenticated="false"/>
            <div class="c-body">
                <main class="c-main">
                    <CContainer fluid>
                        <transition name="fade">
                            <slot></slot>
                        </transition>
                    </CContainer>
                </main>
            </div>
        </CWrapper>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Sidebar from '@/components/Sidebar'

    export default {
        components: {
            Header,
            Sidebar
        }
    }
</script>
